import React from "react";
import "./SignUpPage.css";

const SignUpPage = () => {
  return (
    <div className="signup-page">
      <header className="signup-header">
        <h1>Create Your Account</h1>
        <p>Fill out the form below and we'll get you set up in no time.</p>
      </header>

      <form className="signup-form">
        <div className="form-row">
          <input type="text" placeholder="First Name" required />
          <input type="text" placeholder="Last Name" required />
        </div>
        <input type="text" placeholder="Company Name" required />
        <input type="email" placeholder="Email" required />
        <input type="tel" placeholder="Phone" required />
        <div className="form-row">
          <input type="number" placeholder="Cars per Month" required />
          <input type="number" placeholder="Estimated Users" required />
        </div>
        <button type="submit">Sign Up</button>
      </form>

      <footer className="signup-footer">
        <p>&copy; 2025 CRM Panel. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default SignUpPage;
